import React from 'react';
import { Grid } from '@mui/material';
import Banner from '../../components/services/Banner';
import { Helmet } from 'react-helmet';
import AcService from '../../components/services/ac'

const AC = () => {

    const faqSchema3 = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What types of projects do you handle as an air conditioning contractor in India?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "We handle commercial buildings, industrial plants, healthcare facilities, data centres, and institutional campuses across diverse climatic zones."
    }
  },{
    "@type": "Question",
    "name": "How early should air system planning begin within a project lifecycle?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Planning should begin during concept design stages. Early involvement reduces redesign costs and coordination conflicts later."
    }
  },{
    "@type": "Question",
    "name": "Do you work alongside other service contractors on large sites?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. We regularly coordinate with plumbing, electrical, automation, and safety teams to maintain system compatibility."
    }
  },{
    "@type": "Question",
    "name": "How do you ensure energy efficiency without sacrificing performance?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "We balance load calculations, control strategies, and equipment selection to achieve stable efficiency across real operating conditions."
    }
  },{
    "@type": "Question",
    "name": "What support do clients receive after system commissioning?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Clients receive documentation, training, maintenance planning support, and technical assistance during audits or future upgrades."
    }
  }]

    };

    return (
        <Grid container style={{width:'100%', justifyContent:'center'}}>
            <Helmet>
<title>Air Conditioning Contractor in India | Unique Engineers</title>
<meta name="description" content="Choose Unique Engineers as your air conditioning contractor in India for professional HVAC solutions, seamless project execution and superior indoor comfort." />
<link rel="canonical" href="https://www.uniqueengineersltd.com/services/air-conditioning-contractor-in-india/" />

         <script type="application/ld+json">
                    {JSON.stringify(faqSchema3)}
                </script>

            </Helmet>
             <Banner img={'/assets/images/electrical-banner.jpg'} title= 'React out and Connect' />
            <AcService />
        </Grid>
    )

}

export default AC;